import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useRef, useState } from 'react';
import styled, { css, ThemeProvider } from 'styled-components';
import _theme from './theme';
import HeaderLogo from './components/HeaderLogo';
import { Box, checkUserInfo, Hide, Link, LanguageSwitcher, useWindowSize } from '@miro-site/core';
import ContactSalesLink from './components/ContactSalesLink';
import TopNavigation from './components/TopNavigation';
import CtaNavigation from './components/CtaNavigation';
import BurgerMenu from './components/BurgerMenu';
import AccordionMenu from './components/AccordionMenu';
import HeaderContainer from './components/HeaderContainer';
import SecondaryNavigationContainer from './components/SecondaryNavigationContainer';
import NavigationOverlay from './components/NavigationOverlay';
import { usePageTranslations } from '@miro-site/localization';
import { useLocalization } from '@miro-site/localization';
import { isDarkTheme } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledHeader = styled(Box).attrs({
  as: 'header',
  $styles: {
    fontFamily: 'Formular',
    fontFeatureSettings: "'ss03'"
  }
}).withConfig({
  displayName: "Header__StyledHeader",
  componentId: "sc-3qz8ss-0"
})(["*,*:before,*:after{box-sizing:border-box;}"]);
StyledHeader.displayName = 'StyledHeader';
var HeaderRoot = styled(Box).attrs(function (_ref) {
  var $isMobileMenuOpened = _ref.$isMobileMenuOpened,
      $appearance = _ref.$appearance,
      header = _ref.theme.header;
  return {
    $styles: {
      zIndex: 10,
      position: 'relative',
      background: $isMobileMenuOpened || isDarkTheme($appearance) ? _theme.header.backgroundDark : _theme.header.background,
      borderBottom: isDarkTheme($appearance) ? 'none' : header.secondaryNavigation.stroke,
      color: isDarkTheme($appearance) ? _theme.header.colors.white : _theme.header.colors.indigo
    }
  };
}).withConfig({
  displayName: "Header__HeaderRoot",
  componentId: "sc-3qz8ss-1"
})(["transition:background 250ms ease;"]);
var HeaderNav = styled(Box).attrs(function (_ref2) {
  var theme = _ref2.theme;
  return {
    as: 'nav',
    $styles: {
      height: theme.header.height,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flexFlow: 'row nowrap',
      paddingRight: theme.header.navigation.padding.right
    }
  };
}).withConfig({
  displayName: "Header__HeaderNav",
  componentId: "sc-3qz8ss-2"
})(["", "{", "}"], LanguageSwitcher.SwitcherCurrentLocale, function (_ref3) {
  var theme = _ref3.theme;
  return theme.normalizeStyles({
    fontSize: theme.header.topNavigation.fontSize,
    lineHeight: theme.header.topNavigation.lineHeight,
    display: ['block', 'block', 'none', 'block', 'block']
  });
});
var AccordionMobileContainer = styled(Box).attrs(function (_ref4) {
  var theme = _ref4.theme,
      $isMobileMenuOpened = _ref4.$isMobileMenuOpened;
  return {
    $styles: {
      background: 'primaryIndigo',
      overflowY: 'auto',
      position: 'fixed',
      top: theme.header.height,
      left: 0,
      right: 0,
      bottom: 0,
      opacity: 0,
      visibility: 'hidden',
      transition: 'opacity 250ms ease, visibility 250ms ease'
    }
  };
}).withConfig({
  displayName: "Header__AccordionMobileContainer",
  componentId: "sc-3qz8ss-3"
})(["", ""], function (_ref5) {
  var $isMobileMenuOpened = _ref5.$isMobileMenuOpened;
  return $isMobileMenuOpened && css(["opacity:1;visibility:visible;"]);
});
var MobileControls = styled(Box).attrs({
  $styles: {
    textAlign: 'center',
    paddingTop: 64,
    paddingBottom: 36
  }
}).withConfig({
  displayName: "Header__MobileControls",
  componentId: "sc-3qz8ss-4"
})([""]);
var MobileLinksContainer = styled(Box).attrs({
  $styles: {
    marginTop: 23,
    marginBottom: 20
  }
}).withConfig({
  displayName: "Header__MobileLinksContainer",
  componentId: "sc-3qz8ss-5"
})([""]);
var MobileLink = styled(Link).attrs({
  $mx: 10
}).withConfig({
  displayName: "Header__MobileLink",
  componentId: "sc-3qz8ss-6"
})([""]);
var LanguageSwitcherContainer = styled(Box).attrs({
  $styles: {
    display: 'flex',
    justifyContent: 'center'
  }
}).withConfig({
  displayName: "Header__LanguageSwitcherContainer",
  componentId: "sc-3qz8ss-7"
})([""]);
var LoginLink = styled(Link).attrs(function (_ref6) {
  var $appearance = _ref6.$appearance,
      theme = _ref6.theme;
  return {
    $styles: {
      fontSize: theme.header.topNavigation.fontSize,
      lineHeight: theme.header.topNavigation.lineHeight,
      display: 'block',
      color: 'inherit',
      ':hover': {
        color: isDarkTheme($appearance) ? theme.colors.outspoken : theme.header.topNavigation.hoverColor
      }
    }
  };
}).withConfig({
  displayName: "Header__LoginLink",
  componentId: "sc-3qz8ss-8"
})(["", ""], function (_ref7) {
  var theme = _ref7.theme;
  return theme.normalizeStyles({
    ':focus': _objectSpread({}, theme.focus.outlines.withOffset)
  });
});

var Header = function Header(props) {
  var label = props.label,
      productNavigation = props.productNavigation,
      solutionsNavigation = props.solutionsNavigation,
      resourcesNavigation = props.resourcesNavigation,
      enterpriseLink = props.enterpriseLink,
      pricingLink = props.pricingLink,
      contactSalesLink = props.contactSalesLink,
      loginLink = props.loginLink,
      dashboardButton = props.dashboardButton,
      signupButton = props.signupButton,
      bottomLinks = props.bottomLinks,
      customerSpotlight = props.customerSpotlight,
      templates = props.templates,
      whatsNew = props.whatsNew,
      _props$containerNode = props.containerNode,
      containerNode = _props$containerNode === void 0 ? null : _props$containerNode,
      _props$appearance = props.appearance,
      appearance = _props$appearance === void 0 ? 'light' : _props$appearance,
      className = props.className;
  var mobileMenuData = [productNavigation, solutionsNavigation, resourcesNavigation, enterpriseLink, pricingLink];

  var _useState = useState(),
      userId = _useState[0],
      setUserId = _useState[1];

  var _useState2 = useState(false),
      isMobileMenuOpened = _useState2[0],
      setIsMobileMenuOpened = _useState2[1];

  var _useState3 = useState(null),
      activeNavigation = _useState3[0],
      setActiveNavigation = _useState3[1];

  var _usePageTranslations = usePageTranslations(),
      _usePageTranslations2 = _slicedToArray(_usePageTranslations, 2),
      switcherData = _usePageTranslations2[0],
      onChangeLocale = _usePageTranslations2[1].onChangeLocale;

  var _useWindowSize = useWindowSize(),
      width = _useWindowSize.width;

  var _useLocalization = useLocalization(),
      currentLocale = _useLocalization.currentLocale;

  var isRUlocale = currentLocale == 'ru' ? true : false;
  var isMobileScreen = typeof width === 'number' && width <= _theme.breakpoints.v2Tablet;
  var activeNavigationRef = useRef(null);
  useEffect(function () {
    var _ref8 = checkUserInfo() || {},
        _ref8$id = _ref8.id,
        userId = _ref8$id === void 0 ? 0 : _ref8$id;

    setUserId(userId);
  }, []);
  useEffect(function () {
    if (containerNode) {
      if (isMobileMenuOpened) {
        containerNode.classList.add('mobile-menu-opened');
      } else {
        containerNode.classList.remove('mobile-menu-opened');
      }
    }

    document.body.style.overflow = isMobileMenuOpened ? 'hidden' : '';
  }, [isMobileMenuOpened]);

  var toggleNavigation = function toggleNavigation(navigation) {
    setActiveNavigation(function (current) {
      return current === navigation ? null : navigation;
    });
  };

  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: function theme(defaultTheme) {
      return _objectSpread(_objectSpread({}, defaultTheme), _theme);
    },
    children: /*#__PURE__*/_jsxs(StyledHeader, {
      "data-place": "Header",
      className: className,
      children: [/*#__PURE__*/_jsx(HeaderRoot, {
        $appearance: appearance,
        $isMobileMenuOpened: isMobileMenuOpened,
        children: /*#__PURE__*/_jsxs(HeaderContainer, {
          children: [/*#__PURE__*/_jsxs(HeaderNav, {
            "aria-label": label,
            "data-track-place": "Header",
            children: [/*#__PURE__*/_jsx(HeaderLogo, {
              href: "/",
              color: isMobileMenuOpened || isDarkTheme(appearance) ? 'white' : 'primaryIndigo'
            }), !isMobileMenuOpened && /*#__PURE__*/_jsx(TopNavigation, {
              onToggleNavigation: toggleNavigation,
              activeNavigationRef: activeNavigationRef,
              activeNavigation: activeNavigation,
              productNavigation: productNavigation,
              solutionsNavigation: solutionsNavigation,
              resourcesNavigation: resourcesNavigation,
              templates: templates,
              customerSpotlight: customerSpotlight,
              whatsNew: whatsNew,
              enterpriseLink: enterpriseLink,
              pricingLink: pricingLink,
              appearance: appearance
            }), !isMobileMenuOpened && /*#__PURE__*/_jsxs(CtaNavigation, {
              children: [/*#__PURE__*/_jsx(Hide, {
                $on: ['v2Mobile'],
                children: switcherData && /*#__PURE__*/_jsx(LanguageSwitcher, _objectSpread({
                  color: isDarkTheme(appearance) ? 'white' : undefined,
                  onSelect: function onSelect(e, link) {
                    onChangeLocale(link.locale);
                  }
                }, switcherData))
              }), /*#__PURE__*/_jsx(Hide, {
                $on: ['v2Mobile'],
                children: isRUlocale ? null : /*#__PURE__*/_jsx(ContactSalesLink, {
                  href: contactSalesLink.path,
                  label: contactSalesLink.title,
                  appearance: appearance
                })
              }), userId !== undefined && userId === 0 && /*#__PURE__*/_jsx(Hide, {
                $on: ['v2Mobile'],
                children: /*#__PURE__*/_jsx(LoginLink, {
                  href: loginLink.path,
                  $color: "default",
                  $size: "default",
                  $appearance: appearance,
                  children: loginLink.title
                })
              }), userId !== undefined && (userId > 0 ? /*#__PURE__*/_jsx(CtaNavigation.Button, {
                href: dashboardButton.path,
                children: dashboardButton.title
              }) : /*#__PURE__*/_jsx(CtaNavigation.Button, {
                href: signupButton.path,
                needReferer: true,
                children: signupButton.title
              }))]
            }), (isMobileMenuOpened || isMobileScreen) && /*#__PURE__*/_jsx(BurgerMenu, {
              appearance: appearance,
              onClick: function onClick() {
                setIsMobileMenuOpened(!isMobileMenuOpened);
              },
              $isMobileMenuOpened: isMobileMenuOpened
            })]
          }), /*#__PURE__*/_jsxs(AccordionMobileContainer, {
            $isMobileMenuOpened: isMobileMenuOpened,
            children: [/*#__PURE__*/_jsx(AccordionMenu, {
              categories: mobileMenuData
            }), isMobileScreen && /*#__PURE__*/_jsxs(MobileControls, {
              children: [userId !== undefined && (userId > 0 ? /*#__PURE__*/_jsx(CtaNavigation.Button, {
                href: dashboardButton.path,
                $isMobileButton: true,
                children: dashboardButton.title
              }) : /*#__PURE__*/_jsx(_Fragment, {
                children: /*#__PURE__*/_jsx(CtaNavigation.Button, {
                  href: signupButton.path,
                  needReferer: true,
                  $isMobileButton: true,
                  children: signupButton.title
                })
              })), /*#__PURE__*/_jsxs(MobileLinksContainer, {
                children: [/*#__PURE__*/_jsx(MobileLink, {
                  href: loginLink.path,
                  $color: "white",
                  $size: "default",
                  children: loginLink.title
                }), isRUlocale ? null : /*#__PURE__*/_jsx(MobileLink, {
                  href: contactSalesLink.path,
                  $color: "white",
                  $size: "default",
                  children: contactSalesLink.title
                })]
              }), /*#__PURE__*/_jsx(LanguageSwitcherContainer, {
                children: switcherData && /*#__PURE__*/_jsx(LanguageSwitcher, _objectSpread(_objectSpread({}, switcherData), {}, {
                  onSelect: function onSelect(e, link) {
                    onChangeLocale(link.locale);
                  },
                  color: "white",
                  position: "top"
                }))
              })]
            })]
          })]
        })
      }), !isMobileScreen && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(SecondaryNavigationContainer, {
          isFixed: false,
          activeNavigation: activeNavigation,
          activeNavigationRef: activeNavigationRef,
          bottomLinks: bottomLinks
        }), /*#__PURE__*/_jsx(NavigationOverlay, {
          onClick: function onClick() {
            return setActiveNavigation(null);
          },
          $isActive: activeNavigation !== null
        })]
      })]
    })
  });
};

export default Header;